import React from 'react'

class Arrows extends React.PureComponent {
  static defaultProps = {
    viewBox: '0 0 18 18',
    color: '#000',
    width: '15px',
    title: 'Arrows Icon',
    isFilled: false,
  }

  matchIcon = (icontype, iconcolor, disableicon, customicon) => {
    switch (icontype) {
      case 'uparrow':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 0.128906 10.019531 L 0.335938 10.214844 C 0.46875 10.34375 0.691406 10.34375 0.828125 10.214844 L 6.5 4.867188 L 12.171875 10.214844 C 12.308594 10.34375 12.527344 10.34375 12.664062 10.214844 L 12.871094 10.019531 C 13.007812 9.894531 13.007812 9.683594 12.871094 9.558594 L 6.746094 3.785156 C 6.609375 3.65625 6.390625 3.65625 6.253906 3.785156 L 0.128906 9.558594 C -0.0078125 9.683594 -0.0078125 9.894531 0.128906 10.019531 Z M 0.128906 10.019531 "
            />
          </>
        )
      case 'downarrow':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 12.871094 4.445312 L 12.664062 4.25 C 12.527344 4.125 12.304688 4.125 12.171875 4.25 L 6.5 9.597656 L 0.828125 4.25 C 0.691406 4.125 0.46875 4.125 0.332031 4.25 L 0.128906 4.445312 C -0.0078125 4.574219 -0.0078125 4.78125 0.128906 4.910156 L 6.25 10.683594 C 6.386719 10.8125 6.605469 10.8125 6.742188 10.683594 L 12.867188 4.910156 C 13.003906 4.78125 13.003906 4.574219 12.871094 4.445312 Z M 12.871094 4.445312 "
            />
          </>
        )
      case 'forwardarrow':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 0.546875 1.140625 L 0.328125 1.359375 C 0.179688 1.507812 0.179688 1.746094 0.328125 1.890625 L 6.4375 8 L 0.328125 14.109375 C 0.179688 14.253906 0.179688 14.492188 0.328125 14.640625 L 0.546875 14.859375 C 0.695312 15.007812 0.929688 15.007812 1.078125 14.859375 L 7.671875 8.265625 C 7.820312 8.117188 7.820312 7.882812 7.671875 7.734375 L 1.078125 1.140625 C 0.929688 0.992188 0.695312 0.992188 0.546875 1.140625 Z M 0.546875 1.140625 "
            />
          </>
        )
      case 'backwardarrow':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 7.453125 14.859375 L 7.671875 14.640625 C 7.820312 14.492188 7.820312 14.253906 7.671875 14.109375 L 1.5625 8 L 7.671875 1.890625 C 7.820312 1.746094 7.820312 1.507812 7.671875 1.359375 L 7.453125 1.140625 C 7.304688 0.992188 7.070312 0.992188 6.921875 1.140625 L 0.328125 7.734375 C 0.179688 7.882812 0.179688 8.117188 0.328125 8.265625 L 6.921875 14.859375 C 7.070312 15.007812 7.304688 15.007812 7.453125 14.859375 Z M 7.453125 14.859375 "
            />
          </>
        )
      case 'dropdown':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 0.683594 4.125 L 6.3125 4.125 C 6.703125 4.125 6.898438 4.585938 6.621094 4.859375 L 3.808594 7.621094 C 3.636719 7.789062 3.359375 7.789062 3.1875 7.621094 L 0.375 4.859375 C 0.101562 4.585938 0.296875 4.125 0.683594 4.125 Z M 0.683594 4.125 "
            />
          </>
        )
      case 'rightarrow':
        return (
          <>
            <title>{icontype.icontype + ' icon'}</title>
            <path
              fill={iconcolor}
              d="M 7.246094 1.210938 L 7.011719 1.445312 C 6.855469 1.601562 6.855469 1.851562 7.011719 2.007812 L 12.988281 7.9375 L 0.402344 7.9375 C 0.179688 7.9375 0 8.113281 0 8.335938 L 0 8.664062 C 0 8.886719 0.179688 9.0625 0.402344 9.0625 L 12.988281 9.0625 L 7.011719 14.992188 C 6.855469 15.148438 6.855469 15.398438 7.011719 15.554688 L 7.246094 15.789062 C 7.40625 15.945312 7.660156 15.945312 7.816406 15.789062 L 14.882812 8.78125 C 15.039062 8.625 15.039062 8.375 14.882812 8.21875 L 7.816406 1.210938 C 7.660156 1.054688 7.40625 1.054688 7.246094 1.210938 Z M 7.246094 1.210938 "
            />
          </>
        )
      case 'bolddownarrow':
        return (
          <>
            {!disableicon && <title>{customicon || icontype + ' icon'}</title>}
            <path
              fill={iconcolor}
              d="M 15.9293 6.5894 h -2.8558 V 1.7971 c 0 -0.9921 -0.832 -1.7971 -1.8575 -1.7971 H 7.0213 c -1.0255 0 -1.8575 0.8049 -1.8575 1.7971 v 4.7923 H 2.3118 c -1.6485 0 -2.4843 1.9356 -1.3118 3.0663 l 6.8068 6.5894 c 0.7236 0.7001 1.9 0.7001 2.6275 0 l 6.8107 -6.5894 c 1.1609 -1.1269 0.3367 -3.0663 -1.3157 -3.0663 z M 9.1186 14.9758 L 2.308 8.3864 h 4.7133 V 1.7971 h 4.1909 v 6.5894 H 15.9293 L 9.1186 14.9758 z"
            />
          </>
        )
      default:
        return undefined
    }
  }

  render() {
    const {
      className,
      icontype,
      viewBox,
      //color,
      width,
      //title,
      dataTestId,
      ariaLabel,
      ariaHidden,
      //isFilled,
      onClick,
    } = this.props
    const iconcolor = this.props?.color || '#000'
    const disableicon = this.props?.disableicon || false
    const customicon = this.props?.customicon || ''
    return (
      <svg
        className={className}
        viewBox={viewBox}
        version="1.1"
        style={{ width: width }}
        data-testid={dataTestId}
        onClick={onClick}
        aria-label={ariaLabel}
        aria-hidden={ariaHidden}>
        {this.matchIcon(icontype, iconcolor, disableicon, customicon)}
      </svg>
    )
  }
}

export { Arrows }
export default Arrows
